import { css } from "../../../component-styles";

export const dark = css`
  :host {
    --bg: #1a1a1a;
    --bg-elevated: #242424;
    --text-pri: #e8e4dc;
    --text-sec: #a8a49c;
    --text-ter: #6e6a62;
    --divider: rgba(255, 255, 255, 0.08);
    --hover-color: rgba(255, 255, 255, 0.04);
    --blue: #60a5fa;
  }
`;
